/**
 * Immutable View: what a screen shows of one element — a title and a one-line subtitle — resolved from
 * the interview or the document the element points at.
 */
class ElementDescription {
	readonly title: string;
	readonly subtitle: string;

	constructor(title: string, subtitle: string) {
		this.title = title;
		this.subtitle = subtitle;

		Object.freeze(this);
	}
}

export default ElementDescription;
